const SectionTitle = ({ 
  title, 
  subtitle, 
  align = 'center',
  className = '' 
}) => {
  const alignStyles = {
    left: 'text-left',
    center: 'text-center mx-auto',
    right: 'text-right ml-auto',
  }
  
  return (
    <div className={`mb-8 sm:mb-10 md:mb-12 ${align === 'center' ? 'max-w-3xl mx-auto' : ''} ${className}`}>
      <div className={alignStyles[align]}>
        {subtitle && (
          <p className="text-xs sm:text-sm font-extrabold text-accent uppercase tracking-[0.25em] mb-2 sm:mb-3">
            {subtitle}
          </p>
        )}
        <h2 className="text-fluid-3xl lg:text-fluid-4xl font-extrabold text-gray-900 dark:text-white leading-[1.15] tracking-tight break-words">
          {title}
        </h2>
        <div 
          className={`mt-3 h-0.5 sm:h-1 rounded-full ${align === 'center' ? 'mx-auto' : align === 'right' ? 'ml-auto' : ''}`}
          style={{ width: '48px', background: 'linear-gradient(90deg, #22C65E 0%, #2dda70 100%)' }}
        />
      </div>
    </div>
  )
}

export default SectionTitle
